import React, {
  Component,
  PropTypes as T,
} from 'react';
import radium from 'radium';
import * as ReservationActions from '../../actions/Reservation.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import ReservationMap from './ReservationMap.js';
import ReservationStoreList from './ReservationStoreList.js';
import ReservationFormModal from './ReservationFormModal.js';

const styles = {
  wrap: {
    display: 'flex',
    height: '100vh',
    '@media (max-width: 767px)': {
      flexDirection: 'column-reverse',
      width: '100%',
      height: '100%',
    },
  },
};

class Reservations extends Component {
  constructor(props) {
    super(props);

    const {
      cities,
      selectedCity,
    } = props;

    if (!selectedCity) {
      this.state = {
        selectedCity: cities.length ? cities[0].id : null,
      };
    } else {
      this.state = {
        selectedCity,
      };
    }
  }

  componentDidMount() {
    this.props.fetchShopCities();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.cities !== this.props.cities && nextProps.cities.length) {
      this.setState({
        selectedCity: nextProps.cities[0].id,
      });
      this.props.fetchShopCityList(nextProps.cities[0].id);
    }
  }

  selectCity(cityId) {
    const {
      selectedCity,
    } = this.state;

    if (cityId !== selectedCity) {
      this.setState({
        selectedCity: cityId,
      });

      this.props.updateCity(cityId);
      this.props.fetchShopCityList(cityId);
    }
  }

  render() {
    const {
      cities,
      selectedCityMap,
      cityList,
    } = this.props;

    const {
      selectedCity,
    } = this.state;

    if (!selectedCity || !selectedCityMap) return null;

    return (
      <div style={styles.wrap}>
        <ReservationStoreList
          cities={cities}
          selectedCity={selectedCity}
          cityList={cityList} />
        <ReservationMap
          cities={cities}
          selectedCity={selectedCity}
          selectedCityMap={selectedCityMap}
          selectCity={(id) => this.selectCity(id)} />
        <ReservationFormModal />
      </div>
    );
  }
}

Reservations.propTypes = {
  cities: T.array,
  fetchShopCities: T.func,
  selectedCity: T.number,
  updateCity: T.func,
  selectedCityMap: T.string,
  fetchShopCityList: T.func,
  cityList: T.array,
};

export default connect(
  state => ({
    cities: state.Reservation.cities,
    selectedCityMap: state.Reservation.selectedCityMap,
    cityList: state.Reservation.cityList,
  }),
  dispatch => bindActionCreators(ReservationActions, dispatch),
)(radium(Reservations));



// WEBPACK FOOTER //
// ./containers/Reservations/Reservations.js